import { render, staticRenderFns } from "./RegionApplication.vue?vue&type=template&id=171bc437&"
import script from "./RegionApplication.vue?vue&type=script&lang=js&"
export * from "./RegionApplication.vue?vue&type=script&lang=js&"
import style0 from "./RegionApplication.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports